<template>
    <Component
        :is="'h' + level"
        :class="
            level === '3'
                ? 'text-20/120 lg:text-24/133'
                : 'text-24/100 lg:text-48/100'
        "
        class="font-semibold tracking-tighter">
        <slot />
    </Component>
</template>

<script setup lang="ts">
defineProps({
    level: {
        type: String as PropType<'1' | '2' | '3'>,
        default: '2',
    },
})
</script>
